// Mirror of cobstream-backend/src/services/sportsVodStreaming/sportsVod.types.ts
// Hand-mirrored (no codegen) the same way types/sports.ts and types/streaming.ts
// mirror their backend counterparts. Drift surfaces as runtime narrowing failures
// in the components and tests that consume this surface.

export const SPORTS_VOD_SOURCES = [
  'fullfightreplays',
  'watchwrestling',
  'nflvideo',
  'fullraces',
  'mlblive',
  'basketballreplays',
] as const;
export type SportsVodSource = (typeof SPORTS_VOD_SOURCES)[number];

export function isKnownSportsVodSource(value: unknown): value is SportsVodSource {
  return typeof value === 'string' && (SPORTS_VOD_SOURCES as readonly string[]).includes(value);
}

/**
 * Persisted shape returned by `GET /api/sports-vod/:id` and the (Plan-05)
 * library route. `sport` is a free-form string here — the canonical sport
 * taxonomy lives in `types/sports.ts` (CanonicalSportId) but is not narrowed
 * at this boundary because new sports may appear ahead of the frontend mirror.
 */
export interface SportsVodTitle {
  id: string;
  source: SportsVodSource;
  externalId: string;
  sport: string;
  title: string;
  posterUrl: string | null;
  durationMs: number | null;
  /** ISO timestamp from the upstream sitemap / page metadata; null if unknown. */
  postedAt: string | null;
  ingestedAt: string;
}

/** Cursor-paged response from `GET /api/sports-vod/library`. */
export interface SportsVodLibraryPage {
  titles: SportsVodTitle[];
  nextCursor: string | null;
}

/** Sport id + count returned by `GET /api/sports-vod/sports`. */
export interface SportsVodSportInfo {
  id: string;
  count: number;
}
